var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.996,
    height: 19.531,
    viewBox: "0 0 16.996 19.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843",
    transform: "translate(574.852 -20241.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839",
    transform: "translate(-3.852 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-570.996 20240.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M16.217,18.074l-.321-.409-1.522,1.69h0a.411.411,0,0,1-.62,0L12.2,17.679l-1.519,1.636a.411.411,0,0,1-.617.019L8.458,17.679,6.994,19.354l-.027.032a.409.409,0,0,1-.626,0L4.809,17.679,3.227,19.355h0a.411.411,0,0,1-.617,0l-1.5-1.7-.312.4a.432.432,0,0,1-.354.2A.468.468,0,0,1,0,17.762V.491A.466.466,0,0,1,.436,0H16.549a.468.468,0,0,1,.443.491V17.759h0a.507.507,0,0,1-.154.37.4.4,0,0,1-.618-.048ZM2.616,2.835h3.6V3.918h-1.2v3.17h-1.2V3.918h-1.2V2.835ZM8.722,6.42H7.448l-.186.668H6.021L7.457,2.835H8.748l1.43,4.253H8.9l-.177-.666Zm-.22-1L8.086,3.9,7.668,5.422Zm1.772-2.584h1.3l.675,1.308.663-1.308H14.2L13.014,4.894l1.3,2.194H12.983l-.748-1.364-.755,1.364H10.164l1.317-2.215ZM12.6,13.508a.379.379,0,0,1,0,.75H3.363a.379.379,0,0,1,0-.75Zm1.846-2.419a.379.379,0,0,1,0,.751H3.268a.379.379,0,0,1,0-.751Zm.016-2.419a.372.372,0,0,1,.312.494.34.34,0,0,1-.324.257H3.268a.379.379,0,0,1,0-.751ZM16.09,1H.9V16.538a.406.406,0,0,1,.493.064.122.122,0,0,1,.025.027h0l1.531,1.724,1.575-1.675a.411.411,0,0,1,.617,0h0L6.654,18.37l1.471-1.689a.409.409,0,0,1,.615-.018h0l1.618,1.667,1.536-1.641a.409.409,0,0,1,.615,0l1.538,1.666,1.543-1.713a.408.408,0,0,1,.5-.1Z",
    transform: "translate(0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M0,17.762C-.017.234-.016,18.02,0,17.762ZM2.616,2.835h3.6V3.918h-1.2v3.17h-1.2V3.918h-1.2V2.835ZM8.722,6.42H7.448l-.186.668H6.021L7.457,2.835H8.748l1.43,4.253H8.9l-.177-.666Zm-.22-1L8.086,3.9,7.668,5.422Zm1.772-2.584h1.3l.675,1.308.663-1.308H14.2L13.014,4.894l1.3,2.194H12.983l-.748-1.364-.755,1.364H10.164l1.317-2.215ZM12.6,13.508a.379.379,0,0,1,0,.75H3.363a.379.379,0,0,1,0-.75Zm1.846-2.419a.379.379,0,0,1,0,.751H3.268a.379.379,0,0,1,0-.751Zm.016-2.419a.372.372,0,0,1,.312.494.34.34,0,0,1-.324.257H3.268a.379.379,0,0,1,0-.751Z",
    transform: "translate(0.013)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxes);
export default __webpack_public_path__ + "static/media/taxes.43d14fb6e127b7438ac514ac95afd427.svg";
export { ForwardRef as ReactComponent };